<div class="unauthorized-container">
    <h2>Unauthorized Access</h2>
    <p>You do not have permission to view this page.</p>
    <a routerLink="/">Return to Dashboard</a>
</div>
  